export default "__VITE_ASSET__DKlpKMoU__"